import { useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';

import { debugLinkedInQueryKeys } from './queryKeys';

export function useDebugLinkedInThreadsQuery(accountId: string | null) {
  return useQuery({
    queryKey: debugLinkedInQueryKeys.threads(accountId),
    queryFn: async () => {
      const { data } = await fetchClient.GET('/debug/linkedin/threads', {
        params: { query: { accountId: accountId! } },
      });
      return data ?? [];
    },
    enabled: Boolean(accountId),
  });
}
